import Vue from 'vue';
import VueRouter from 'vue-router';

import Landing from '@/pages/Landing';
import TermsOfUse from '@/pages/TermsOfUse';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import MainNavbar from '@/layout/MainNavbar';
import MainFooter from '@/layout/MainFooter';

Vue.use(VueRouter);

const routes = [].concat(
    {
        path: '/',
        name: 'landing',
        components: { default: Landing, header: MainNavbar, footer: MainFooter },
        props: {
            header: { colorOnScroll: 400 },
            footer: { backgroundColor: 'black' }
        }
    },
    {
        path: '/legal/termos-de-uso',
        name: 'terms-of-use',
        components: { default: TermsOfUse, header: MainNavbar, footer: MainFooter },
        props: {
            header: { colorOnScroll: 150 },
            footer: { backgroundColor: 'black' }
        }
    },
    {
        path: '/legal/politica-de-privacidade',
        name: 'privacy-policy',
        components: { default: PrivacyPolicy, header: MainNavbar, footer: MainFooter },
        props: {
            header: { colorOnScroll: 150 },
            footer: { backgroundColor: 'black' }
        }
    },
    {
        path: '/.*',
        redirect: () => {
            // Reload força o erro 404 do Laravel
            location.reload();
        },
    }
);

const Router = new VueRouter({
    mode: 'history',
    pathToRegexpOptions: { strict: true },
    linkExactActiveClass: 'active',
    scrollBehavior: (to) => {
        if(to.hash) {
            return { selector: to.hash };
        }
        else {
            return { x: 0, y: 0 };
        }
    },
    routes,
});

// https://router.vuejs.org/guide/advanced/navigation-guards.html
Router.beforeEach((to, from, next) => {
    if(to.meta.title) {
        document.title = `${to.meta.title} - Leviatan`;
    }
    else {
        document.title = 'Leviatan';
    }
    next();
});

// Remove o '/' do final da URL para evitar erros com o vue-router
Router.beforeEach((to, from, next) => { // skipcq: JS-0045
    // Ignora o '/' quando é o único caractere, ou seja, quando não já path
    if(to.fullPath.length > 1 && to.fullPath.substr(-1) === '/') {
        return next({
            path: to.fullPath.slice(0, -1)
        });
    }
    next();
});

export default Router;
